var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"relative"}},[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":_vm.$t('returnPre'),"left-arrow":"","fixed":""},on:{"click-left":_vm.onClickLeft}}),_c('div',{staticStyle:{"height":"46px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }